/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CompletionsGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  OrgId: "org_id",
  Model: "model",
} as const;
export type CompletionsGroupBy = ClosedEnum<typeof CompletionsGroupBy>;

/** @internal */
export const CompletionsGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof CompletionsGroupBy
> = z.nativeEnum(CompletionsGroupBy);
/** @internal */
export const CompletionsGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof CompletionsGroupBy
> = CompletionsGroupBy$inboundSchema;
